// Comprimare imagini inainte de upload.
//
// Invitatii urca de pe 4G/5G, unde fiecare MB inseamna timp de asteptare si
// trafic din abonamentul lor. O poza de telefon de 9 MB ajunge la ~2-3 MB fara
// diferenta vizibila intr-o galerie web.
//
// Compresia e blanda intentionat: 2560px pe latura lunga pastreaza detaliul
// pentru vizualizare pe orice ecran si chiar pentru tipariri mici. Scopul e sa
// nu se vada ca a fost comprimata.

const MAX_DIMENSION = 2560;
const QUALITY = 0.85;
const DEFAULT_THRESHOLD = 5 * 1024 * 1024;

export async function compressImage(file, threshold = DEFAULT_THRESHOLD) {
  const isHeic = /\.(heic|heif)$/i.test(file.name || '') || /image\/(heic|heif)/i.test(file.type || '');
  const isImage = (file.type || '').startsWith('image/') || isHeic;

  if (!isImage) return file;
  // HEIC se converteste indiferent de marime. Sharp de pe server nu are decodor
  // HEIF, deci poza ramane fara thumbnail, iar galeria cade pe originalul HEIC —
  // pe care Chrome, Android si Windows nu il pot afisa deloc.
  if (!isHeic && file.size <= threshold) return file;
  if (typeof createImageBitmap !== 'function') return file;

  try {
    // imageOrientation: 'from-image' aplica rotatia din EXIF. Fara ea, pozele
    // facute cu telefonul pe verticala ar ajunge culcate in galerie.
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });

    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(bitmap, 0, 0, width, height);
    if (bitmap.close) bitmap.close();

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', QUALITY));

    if (!blob) return file;
    // Daca re-encodarea nu a ajutat (poza era deja optimizata), pastram originalul.
    // Exceptie HEIC: acolo conversia se face pentru compatibilitate, deci o pastram
    // chiar daca JPEG-ul rezultat e mai mare decat originalul.
    if (!isHeic && blob.size >= file.size) return file;

    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified });
  } catch {
    // HEIC pe Chrome, formate exotice, memorie insuficienta pe telefoane vechi:
    // in toate cazurile trimitem originalul, serverul il accepta oricum.
    return file;
  }
}

export default compressImage;
